import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { NavigationEnd, Router } from '@angular/router';
import { filter, Subscription } from 'rxjs';


export interface Step {
  id: number;
  label: string;
  route: string;
  icon?: string;
  completed: boolean;
  active: boolean;
}

@Component({
  selector: 'app-stepper',
  standalone: true,
  imports: [MatIcon],
  templateUrl: './stepper.component.html',
  styleUrl: './stepper.component.scss'
})
export class StepperComponent implements OnInit, OnDestroy {
  @Input() steps: Step[] = [];
  @Input() allowBackNavigation: boolean = true;

  private routerSubscription: Subscription = new Subscription();
  private maxVisitedStep: number = 1;

  constructor(private readonly router: Router) {}

  ngOnInit() {
    this.initializeFromRoute();
    this.subscribeToRouteChanges();

  }

  ngOnDestroy() {
    this.routerSubscription.unsubscribe();
  }

  private initializeFromRoute() {
    const currentRoute = this.router.url;
    const currentStep = this.steps.find(step => currentRoute.includes(step.route));
    if (currentStep) {
      this.maxVisitedStep = Math.max(this.maxVisitedStep, currentStep.id);
      this.updateStepStates(currentStep.id);
    }
  }

  private subscribeToRouteChanges() {
    this.routerSubscription = this.router.events
      .pipe(filter((event): event is NavigationEnd => event instanceof NavigationEnd))
      .subscribe((event: any) => {
        const currentStep = this.steps.find(step => event.url.includes(step.route));
        if (currentStep) {
          this.maxVisitedStep = Math.max(this.maxVisitedStep, currentStep.id);
          this.updateStepStates(currentStep.id);
        }
      });
  }

  private updateStepStates(currentStepId: number) {
    this.steps.forEach(step => {
      step.completed = step.id < currentStepId;
      step.active = step.id === currentStepId;
    });
  }

  isStepAccessible(stepId: number): boolean {
    return this.allowBackNavigation ? stepId <= this.maxVisitedStep : stepId === this.getCurrentStepId() + 1 || stepId === this.getCurrentStepId() - 1;
  }

  private getCurrentStepId(): number {
    const activeStep = this.steps.find(step => step.active);
    return activeStep ? activeStep.id : 1;
  }

}